import React, { Component } from 'react';

import { Color } from '../../common/types/StockItemTypes';

interface Props {
  colors: Color[];
}

export default class ColorPalette extends Component<Props> {
  render() {
    return (
      <ul className="colors">
        {this.props.colors.map((color, index) => {
          const style = {
            border: this.colorIsTooBright(color.hex_code)
              ? 'solid 1px #cecece'
              : 'none',
            backgroundColor: '#' + color.hex_code,
          };

          return (
            <li key={index} className="colorsColor">
              <div className="colorsColor-link" style={style}>
                {' '}
              </div>
            </li>
          );
        })}
      </ul>
    );
  }

  colorIsTooBright(hexCode) {
    if (hexCode.length !== 6) {
      return false;
    }

    return this.calculateBrightnessForHex(hexCode) > 220;
  }

  /**
   * @credits http://stackoverflow.com/a/12043228
   */
  calculateBrightnessForHex(hexCode) {
    const rgb = parseInt(hexCode, 16); // hex -> decimal
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;

    return 0.2126 * r + 0.7152 * g + 0.0722 * b; // Per ITU-R BT.709
  }
}
